import _extends from "@babel/runtime/helpers/esm/extends";
import { grey } from '../colors';

/**
 * MuiButton
 *
 * Demos:
 *
 * - [Button](https://ui-packages.isbuildingluma.com/ui-core/react-button/)
 *
 * API:
 *
 * - [Button API](https://ui-packages.isbuildingluma.com/ui-core/api/button/)
 * - inherits [MuiButton API](https://mui.com/material-ui/api/button/)
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/atoms.html#buttons)
 */
const MuiButton = {
  defaultProps: {
    disableFocusRipple: true
  },
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => _extends({
      minWidth: 'initial',
      textTransform: 'none',
      boxShadow: 'none',
      fontSize: theme.typography.pxToRem(15),
      transition: 'background-color 0.2s ease-out',
      borderRadius: 4,
      letterSpacing: '.47px',
      lineHeight: '22px',
      textAlign: 'center'
    }, ownerState.variant === 'contained' && ownerState.color === 'primary' && {
      boxShadow: 'none',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: theme.palette.secondary.dark
      }
    }, ownerState.variant === 'contained' && ownerState.color === 'inherit' && {
      boxShadow: 'none',
      backgroundColor: theme.palette.common.white,
      color: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.grey[300]}`,
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: theme.palette.secondary[50],
        color: theme.palette.secondary.dark
      },
      '&:focus': {
        borderColor: theme.palette.secondary.light,
        boxShadow: `inset 0 0 0 1px ${theme.palette.secondary.light}`
      }
    }, ownerState.variant === 'text' && ownerState.color === 'inherit' && {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary[200],
        color: theme.palette.secondary.dark
      }
    }, {
      ' &:focus': {
        boxShadow: theme.shadows[3],
        outlineColor: 'transparent',
        outlineWidth: '2px',
        outlineStyle: 'dotted'
      },
      '&.Mui-disabled': {
        pointerEvents: 'all',
        cursor: 'not-allowed',
        backgroundColor: grey[200],
        color: theme.palette.text.disabled
      }
    }),
    sizeLarge: {
      paddingTop: 13,
      paddingBottom: 13,
      '& .MuiSvgIcon-root': {
        width: 24,
        height: 24
      }
    },
    sizeSmall: {
      paddingTop: 3,
      paddingBottom: 3
    }
  }
};
export const LumaButtonAdd = {
  defaultProps: {
    iconVariant: 'Add'
  }
};
export default MuiButton;